import { render, staticRenderFns } from "./demographic.vue?vue&type=template&id=6f8bf612&lang=pug"
import script from "./demographic.vue?vue&type=script&lang=js"
export * from "./demographic.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports